export default "__VITE_ASSET__Cs$0wZJo__"